<template>
<div v-if="disclaimerText" class="asset-disclaimer" :class="{ show: showFullDisclaimer }">
	<span class="disclmr-txt" > {{ disclaimerText }} </span> 
	<span class="arrow-icon-container">
		<i class="webmd-icon-down-arrow" @click="toggleDisclaimerText"></i>
	</span>
</div>

	<section class="asset-footer" :class="{ expanded: this.isExpanded || this.isSrcExpanded || isArtHistExpanded}">
		<div class="asset-footer-top">
			<div class="asset-footer-buttons" :class="{'espanol':localLang === 'es_ES'}">
				<button class="sources-btn" :class="{ expanded: this.isSrcExpanded, active: activeTab === 'src' }" v-if="sourceData" @click="assetFootertabs('src', isSrcExpanded )">
					{{ translation('Sources') }}
				</button>
				<button class="update-history-btn" :class="{ expanded: this.isArtHistExpanded, active: activeTab === 'hist' }" @click="assetFootertabs('hist', isArtHistExpanded)"  v-if="reviewDate && primaryReviewer.name">
					{{ translation('Update History') }} 
				</button>
				<button class="reviewer-bio-btn" :class="{ expanded: this.isExpanded, active: activeTab === 'bio' }" v-if="primaryReviewer.name && primaryReviewer.intro"
					@click="assetFootertabs('bio', isExpanded)">
					{{ translation('Reviewer Bio') }}
				</button>
			</div>
			<div class="asset-footer-top-share" :class="{'espanol':localLang === 'es_ES'}">
				<webmd-global-sharebar-footer :lang="localLang"/>
				<Print :isArticle="isArticle" :isSlideshow="isSlideShow" :sourcesData="sourceData" :translate="translation" v-if="isArticle || isSlideShow"/>
				<webmd-save-content :lang="localLang"/>
			</div>
		</div>
		<div class="asset-footer-content">
			<div v-show="activeTab ==='src'" class="sources-section" :class="{ srcexpanded: this.isSrcExpanded }">
				<div v-if="sourceData" class="sources-wrapper" v-html="sourceData" v-metric="{ module: 'src' }"></div>
			</div> 

			<div class="art-hist-section" 
			 :class="{expanded: this.isArtHistExpanded}" v-if="reviewDate && activeTab === 'hist'">
			 	<div class="head-section">
			 		<header>{{ historyHeader }}</header>
			 		<span class="sub-text">{{ historySubText }}</span>
				</div>
				<div class="rev-date-section" v-if="reviewDate"> <img
						class="icon"
						src="https://img.webmd.com/vim/staging/webmd/consumer_assets/site_images/articles/rev-date-icon.svg"
					/>
					<span class="review-date">{{ formatDate(reviewDate) }}</span> 
				</div>
				<div>
					<div v-if="primaryReviewer.name" class="hist-bio-name">{{ translation('Medically Reviewed by') }}:  
						<a v-if="primaryReviewer.bioUrl" 
						:href="primaryReviewer.bioUrl"
						v-metric="{module: 'hist-btm',link: 'fullhist'}"> {{ primaryReviewer.name }} </a>
						 <span v-else>
							{{ primaryReviewer.name }}
						</span>
					</div>
				</div>
			</div>
			<div class="bio-section" v-if="primaryReviewer.intro && activeTab === 'bio'"
			 :class="{expanded: this.isExpanded}">
				<div class="bio-header">
					<div v-if="primaryReviewer.photo" class="bio-photo-cont">
						<figure>
							<img :src="primaryReviewer.photo" class="bio-photo" />
						</figure>
					</div>
					<div>
						<div v-if="primaryReviewer.name" class="bio-name">{{ primaryReviewer.name }}</div>
						<div v-if="primaryReviewer.header" class="bio-title">{{ primaryReviewer.header }} </div>
					</div>
				</div>
				<div class="bio-intro" v-if="primaryReviewer.intro" v-html="primaryReviewer.intro"></div>
				<a v-if="primaryReviewer.bioUrl" 
					class="bio-link"
					:href="primaryReviewer.bioUrl"
					v-metric="{module: 'bio-btm',link: 'fullbio'}">{{ translation('View Full Bio') }}</a>
			</div>



		</div>
		<div class="asset-footer-bottom">
			<span class="asset-footer-copyright" v-if="getCopyright">
				{{ getCopyright }}
			</span>
			<a href="https://www.webmd.com/about-webmd-policies/about-privacy-policy" class="asset-footer-policy"
				@click.prevent="triggerFooterModal()">
				View privacy policy, copyright and trust info
			</a>
		</div>
		<div class="asset-footer-bottom-share" :class="{'espanol':localLang === 'es_ES'}">
			<webmd-global-sharebar-footer :lang="localLang"/>
			<Print :isArticle="isArticle" :isSlideshow="isSlideShow" :sourcesData="sourceData" :translate="translation" v-if="isArticle || isSlideShow"/>
			<webmd-save-content :lang="localLang"/>
		</div>
		<div class="asset-footer-mobile-bottom">
			<span class="asset-footer-copyright" v-if="getCopyright">
				{{ getCopyright }}
			</span>
			<a href="https://www.webmd.com/about-webmd-policies/about-privacy-policy" class="asset-footer-policy"
				@click.prevent="triggerFooterModal()">
				View privacy policy, copyright and trust info
			</a>
		</div>
	</section>
</template>

<script>
import useStore from 'webmd-cms-store/src/store';
import WebmdGlobalSharebarFooter from 'webmd-global-sharebar-footer/src/Component.vue';
import WebmdSaveContent from 'webmd-save-content/src/Component.vue';
import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
import Print from './components/Print.vue';
import { getTranslationData } from './helpers/translations.es6';


export default {
	name: 'WebmdAssetFooter',
	components: {
		WebmdGlobalSharebarFooter,
		WebmdSaveContent,
		Print
	},	
	props: {
		sources: {
			type: String,
			default: '',
		},
		metadata: {
			type: Object,
			default() {
				return {};
			},
		},
		chronicId: {
			type: String,
			default: '',
		}
	},

	data() {
		return {
			primaryReviewer: {},
			moduleData: {},
			sourceData: {},
			isExpanded: false,
			isSrcExpanded: false,
			isArtHistExpanded: false,
			reviewDate: '',
			publishDate: '',
			activeTab: '',
			isSlideShow: false,
			isArticle: false,
			localLang: '',
			showFullDisclaimer: true,
			disclaimerText: '',
			historyHeader: 'How we keep our content up to date:',
			historySubText: 'Our medical and editorial staff closely follow the health news cycle, new research, drug approvals, clinical practice guidelines and other developments to ensure our content receives appropriate and timely updates.',
		};
	},
	computed: {
		getCopyright() {
			let copyright = null;
			if (_has(this.metadata, 'wbmd_cpyrt.wbmd_copyright_holder.wbmd_comp_type.wbmd_storage_val')) {
				const copyrightData = this.metadata.wbmd_cpyrt.wbmd_copyright_holder
					.wbmd_comp_type.wbmd_storage_val;
				if (copyrightData === '3') {
					if (_has(this.metadata, 'wbmd_cpyrt.wbmd_copyright.wbmd_copyright_statement')) {
						// eslint-disable-next-line max-len
						copyright = this.metadata.wbmd_cpyrt.wbmd_copyright.wbmd_copyright_statement;
					}
				}
			}
			return copyright;
		},

		getModuleData() {
			return this.store.cms.getModules('articleModule') || this.store.cms.getModules(this.chronicId);
		},

		getSourceData() {
			if (!this.moduleData) {
				return [];
			}

			let citationStringify = '';
			let citationHtml = null;
			let citationData = '';

			const moduleStringify = this.moduleData.module_data ? JSON.stringify(this.moduleData.module_data) : '';
			const regex = /"citations":{"(.*?)"}{1}/i;
			citationData = regex.exec(moduleStringify);

			if (citationData) {
				citationStringify = citationData[0].slice(citationData[0].indexOf('{'));
				citationHtml = JSON.parse(citationStringify)['#cdata-section'];
				const linkPattern = '(link_friendlyurl=")([^"]*)';
				citationHtml = citationHtml.replace(new RegExp(linkPattern, 'gi'), 'href="$2');
			}
			return citationHtml;
		},


		getPrimReviewerDetails() {
			let reviewer = {};

			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_prim_med_revr')) {
				reviewer = (this.moduleData.module_settings.metadata_section.wbmd_prim_med_revr || {});
				// eslint-disable-next-line max-len
				const moduleObj = (this.moduleData.module_settings.metadata_section.wbmd_prim_med_revr || {});
				reviewer.photo = this.getPhoto(moduleObj);
				if (moduleObj && (moduleObj.wbmd_bio_obj_id || moduleObj.wbmd_person)) {
					// eslint-disable-next-line no-nested-ternary
					reviewer.bioUrl = _has(moduleObj, 'wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_bio_obj_id.link_friendlyurl
						: _has(moduleObj, 'wbmd_person.wbmd_bio_obj_id.link_friendlyurl') ? moduleObj.wbmd_person.wbmd_bio_obj_id.link_friendlyurl : '';
					reviewer.intro = _has(moduleObj, 'wbmd_bio_obj_id.content_section.cons_bio.related_links_text') ? moduleObj.wbmd_bio_obj_id.content_section.cons_bio.related_links_text['#cdata-section']
						: _has(moduleObj, 'wbmd_person.content_section.cons_bio.related_links_text') ? moduleObj.content_section.cons_bio.related_links_text['#cdata-section'] : '';
					reviewer.name = this.getName(moduleObj);
					reviewer.header = _has(moduleObj, 'wbmd_bio_obj_id.content_section.cons_bio.related_links_header') ? moduleObj.wbmd_bio_obj_id.content_section.cons_bio.related_links_header
						: _has(moduleObj, 'wbmd_person.content_section.cons_bio.related_links_header') ? moduleObj.content_section.cons_bio.related_links_header : '';
				}
			}
			return reviewer;
		},

		getPrimRevDate() {
			let prmRevDate = '';
			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_prim_revw_dt')) {
				prmRevDate = this.moduleData.module_settings.metadata_section.wbmd_prim_revw_dt;
			}
			return prmRevDate;
		},

		getDisclaimer() {
			let disclaimer= '';
			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_disclmr')) {
				disclaimer = this.moduleData?.module_settings?.metadata_section?.wbmd_disclmr?.wbmd_disclaimer?.disclaimer_statement?.p;
			}
			return disclaimer;
		},

		getPublishDate() {
			let pubDate = '';
			if (_has(this.moduleData, 'module_settings.metadata_section.wbmd_orig_pub_dt')) {
				pubDate = this.moduleData.module_settings.metadata_section.wbmd_orig_pub_dt;
			}
			return pubDate;
		}

	},

	created() {
		this.store = useStore(this.$pinia);
		this.localLang = this.store?.pagedata?.omniture?.s_language_locale;
		this.moduleData = this.getModuleData;
		this.sourceData = this.getSourceData;
		this.primaryReviewer = this.getPrimReviewerDetails;
		this.reviewDate = this.getPrimRevDate;
		this.publishDate = this.getPublishDate;
		this.disclaimerText = this.getDisclaimer;


		if (this.localLang && this.localLang === 'es_ES') {
			this.historyHeader = this.translation('historyHeader');
			this.historySubText = this.translation('historySubText');
			this.showFullDisclaimer = false;

		}

		const busRef = this.moduleData.module_settings.metadata_section.wbmd_bus_ref.wbmd_disp_nm;

		if (busRef === 'Medical Reference' || busRef === 'News' || busRef === 'Feature') {
			this.isArticle = true;
		}
		else if (busRef === 'Tool - Slide Show') {
			this.isSlideShow = true;
		}

	},

	methods: {
		toggleDisclaimerText() {
			this.showFullDisclaimer = !this.showFullDisclaimer;
		},
		assetFootertabs(tabNumber, expandedFlag) {
			this.activeTab = this.activeTab === tabNumber ? '' : tabNumber;
			let moduleName;
			switch (tabNumber) {
				case 'bio':
					moduleName = expandedFlag ? 'bio-btm_cls' : 'bio-btm_xpnd';
					this.isExpanded = !this.isExpanded;
					if (this.isExpanded) {
						this.isSrcExpanded = false;
						this.isArtHistExpanded = false;
					}
					break;
				case 'src':
					moduleName = expandedFlag ? 'src_cls' : 'src_xpnd';
					this.isSrcExpanded = !this.isSrcExpanded;
					if (this.isSrcExpanded) {
						this.isExpanded = false;
						this.isArtHistExpanded = false;
					}
					break;
				default:
					moduleName = expandedFlag ? 'hist-btm_cls' : 'hist-btm_xpnd';
					this.isArtHistExpanded = !this.isArtHistExpanded;
					if (this.isArtHistExpanded) {
						this.isExpanded = false;
						this.isSrcExpanded = false;
					}
			}
			this.$vwmdPageLink({ moduleName });
		},
		triggerFooterModal() {
			const event = new Event('webmd.footer.overlay.open');
			document.dispatchEvent(event);
		},

		getPhoto(moduleObj) {
			// add photo if available
			const imageBaseUrl = this.store?.$state?.pagedata?.omniture?.image_server_url;
			if (_has(moduleObj, 'wbmd_bio_obj_id.content_section.cons_bio.person_photo.path')
				&& moduleObj.wbmd_bio_obj_id.content_section.cons_bio.person_photo.path !== '/webmd/consumer_assets') {
				let reviewerImg = `${imageBaseUrl}${moduleObj.wbmd_bio_obj_id.content_section.cons_bio.person_photo.path}`;
				return reviewerImg;
			}

		},

		formatDate(date) {
			const dt = new Date(date);
			const monthNames = [
				'January', 'February', 'March',
				'April', 'May', 'June', 'July',
				'August', 'September', 'October',
				'November', 'December',
			];

			let day = dt.getDate();
			const monthIndex = dt.getMonth();
			const year = dt.getFullYear();

			day = (day > 9) ? day : (`0${day}`);
			this.formattedDate = monthNames[monthIndex] && day && year && `${monthNames[monthIndex]} ${day}, ${year}`;
			if (this.localLang === 'es_ES') {
				this.formattedDate = ` en ${this.translation(monthNames[monthIndex])} ${day} del ${year}`;
			}
			return this.formattedDate;

		},

		getName(moduleObj) {
			// eslint-disable-next-line no-nested-ternary
			let firstName = _has(moduleObj, 'wbmd_first_nm') ? moduleObj.wbmd_first_nm
				: _has(moduleObj, 'wbmd_person.wbmd_first_nm') ? moduleObj.wbmd_person.wbmd_first_nm : '';
			if (!firstName) {
				firstName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			let middleName = _has(moduleObj, 'wbmd_middle_name') ? moduleObj.wbmd_middle_name
				: _has(moduleObj, 'wbmd_person.wbmd_middle_name') ? moduleObj.wbmd_person.wbmd_middle_name : '';
			if (!middleName) {
				middleName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			let lastName = _has(moduleObj, 'wbmd_lst_nm') ? moduleObj.wbmd_lst_nm
				: _has(moduleObj, 'wbmd_person.wbmd_lst_nm') ? moduleObj.wbmd_person.wbmd_lst_nm : '';
			if (!lastName) {
				lastName = '';
			}
			// eslint-disable-next-line no-nested-ternary
			const suffixData = _has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix') ? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
				: _has(moduleObj, 'wbmd_person.wbmd_person_suffix_group.wbmd_person_suffix') ? moduleObj.wbmd_person.wbmd_person_suffix_group.wbmd_person_suffix : '';

			let nameRes = '';
			let suffix = '';
			if (suffixData && _isArray(suffixData)) {
				suffixData.forEach((x) => {
					if (!firstName && !middleName && !lastName) {
						suffix += `\u00A0${x.wbmd_disp_nm}`;
					} else {
						suffix += `,\u00A0${x.wbmd_disp_nm}`;
					}
				});
			} else if (suffixData && _isObject(suffixData)) {
				if (!firstName && !middleName && !lastName) {
					suffix = (suffixData['@wbmd_disp_nm']) ? `\u00A0${suffixData['@wbmd_disp_nm']}` : `\u00A0${suffixData.wbmd_disp_nm}` || '';
				} else {
					suffix = (suffixData['@wbmd_disp_nm']) ? `,\u00A0${suffixData['@wbmd_disp_nm']}` : `,\u00A0${suffixData.wbmd_disp_nm}` || '';
				}
			}

			nameRes = (`${firstName}${middleName}${lastName}${suffix}`).length > 0 ? `${firstName} ${middleName} ${lastName}`.trim() + suffix : null;
			return nameRes;
		},
		translation(text) {
            return getTranslationData(this.localLang , text) || text; 
        },
	},
};
</script>

<style lang="scss">
$base-font-family-sans: "Source Sans Pro", Arial, sans-serif;
$small-desktop: 64rem;
$disc-tablet: 820px;
$lavender: #CCCCE7;
$ultramarine: #3557FF;
$carbon: #1B1B1B;
$black: #000;
$white: #FFF;
$wave: #D2D9FF;
$darkgray: #676767;

$imperial: #00157C;
$breakpoint-mobile: 47.938rem; // 767px
$breakpoint-small-tablet: 48rem; // 768px
$tablet-breakpoint: 63.9375rem; //1023px

.asset-footer {
	color: $carbon;

	* {
		box-sizing: border-box;
	}


	.asset-footer-top {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.asset-footer-buttons {
			padding-bottom: 2.125rem;

			&.espanol {

				@media screen and (max-width: $tablet-breakpoint) {
					display: flex;
					width: 100%;
				}

				button {
					&:last-child {
						@media screen and (min-width: $small-desktop) and (max-width: 71rem) {
							margin-top: 1rem;
						}
					}
				}

				&:has(> button:nth-child(3)) {
					button {
						@media screen and (min-width: 71rem) {
							margin-right: 0.4rem;
						}
					}

					&:last-child {
						margin-right: 0;
					}
				}
			}

			button {
				cursor: pointer;
				padding: .5rem;
				justify-content: center;
				align-items: center;
				border: 4px $white;
				border-radius: .25rem;
				background: $white;
				color: $ultramarine;
				margin-right: .75rem;
				text-align: center;
				font-family: $base-font-family-sans;
				font-size: 1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 1.6rem;

				&:last-child {
					margin-right: 0;
				}

				&.active {
					background: $wave;
					color: $imperial;
				}

			}

			@media (min-width: $small-desktop) {
				padding-bottom: 1.125rem;
			}
		}
	}

	.asset-footer-bottom {
		border: 0;
		display: none;

		@media (min-width: $small-desktop) {
			border-top: 1px solid $lavender;
			display: flex;
			justify-content: space-between;
		}
	}

	&.expanded {
		.asset-footer-top {
			.asset-footer-buttons {
				padding-bottom: 1.125rem;
			}

		}

		.asset-footer-content {
			margin-bottom: 1.5rem;
		}
	}

	.asset-footer-policy,
	.asset-footer-copyright {
		color: $carbon;
		font-size: px2rem(14);
		margin: px2rem(12) 0;
		text-decoration: none;
	}

	.asset-footer-policy:hover {
		color: $ultramarine;
	}

	.asset-footer-mobile-bottom {
		display: block;

		* {
			display: block
		}

		@media (min-width: $small-desktop) {
			display: none;
		}
	}

	.asset-footer-top-share {
		display: none;

		@media (min-width: $small-desktop) {
			align-items: baseline;
			display: flex;
			padding-top: px2rem(6);

			&.espanol {
				.module .social-share-container .share-footer-container .share-text {
					margin-right: 3px;
				}

				.print-footer-container {
					margin-left: 1rem;
				}

				.print-footer-container .print-text {
					margin-right: 3px;
				}

				.save-container {
					margin-left: 1rem;
				}

				.save-container .auth-overlay-popup-holder .bookmark-holder {
					margin-left: 0;
				}
			}
		}
	}

	.asset-footer-bottom-share {
		align-items: baseline;
		border-bottom: 1px solid $lavender;
		display: flex;
		justify-content: flex-start;

		&.espanol {
			@media (max-width: $breakpoint-small-tablet) {
				justify-content: space-between;
			}

			.print-footer-container {
				@media (max-width: $breakpoint-small-tablet) {
					margin-left: 0;
				}
			}

			.save-container {
				@media (max-width: $breakpoint-small-tablet) {
					margin-left: 0;
				}
			}
		}

		.module-social-share-footer {
			position: relative;

			.share-icons .share-icons-tooltip {
				left: 0;
				right: auto;

				&::after {
					left: 2rem;
				}
			}
		}

		@media (min-width: $small-desktop) {
			display: none;
		}
	}

	.asset-footer-content {
		.sources-section {

			&.srcexpanded {
				display: block;
			}

			.sources-wrapper {
				font-family: $base-font-family-sans;
				font-size: 1rem;
				font-weight: 400;
				line-height: 1.6;

				p {
					letter-spacing: 0;
					line-height: 1.6;
					margin: 8px 0;
				}
			}
		}

		.bio-section {
			letter-spacing: normal;

			&.expanded {
				display: block;
			}

			.bio-header {
				display: flex;
				flex-direction: row;
				align-items: center;

				.bio-photo-cont {
					margin-right: .4375rem;

					figure {
						border: 0.0625rem solid #eef0f4;
						border-radius: 50%;
						height: 3.4375rem;
						margin: 0;
						overflow: hidden;
						width: 55px;

						@media screen and (max-width: $breakpoint-mobile) {
							width: 3.1875rem;
							height: 3.1875rem;
						}

						img {
							width: 55px;

							@media screen and (max-width: $breakpoint-mobile) {
								width: 3.1875rem;
							}
						}
					}
				}

				.bio-name,
				.bio-title {
					color: $black;
					font-family: $base-font-family-sans;
					font-size: 1rem;
					font-style: normal;
					line-height: 1.6rem;
				}

				.bio-name {
					font-weight: 700;
				}

				.bio-title {
					font-weight: 400;
				}
			}

			.bio-intro {
				margin: .9375rem 0 .625rem 0;
				color: $carbon;
				font-family: $base-font-family-sans;
				font-size: 1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 1.6rem;

				p {
					margin: 0;
					line-height: 1.6rem;
				}
			}

			.bio-link {
				color: $ultramarine;
				font-family: $base-font-family-sans;
				font-size: 1.125rem;
				font-style: normal;
				font-weight: 600;
				line-height: 1.8rem;
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}
		}

		.art-hist-section {
			&.expanded {
				display: block;
			}

			.head-section {
				margin-bottom: 1rem;
			}

			header {
				color: $carbon;
				font-family: $base-font-family-sans;
				font-size: 1.125rem;
				font-style: normal;
				font-weight: 600;
				line-height: 1.8rem;
				margin-bottom: .5rem;
			}

			.sub-text,
			.hist-bio-name,
			.hist-bio-name a {
				color: $carbon;
				font-family: $base-font-family-sans;
				font-size: 1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 1.6rem;
			}

			.hist-bio-name {
				margin: 0 0 1rem 2.125rem;

				a {
					&:hover {
						color: $ultramarine;
					}
				}
			}

			.rev-date-section {
				display: flex;
				margin-bottom: 1.25rem;

				.review-date {
					color: $imperial;
					font-family: $base-font-family-sans;
					font-size: 1rem;
					font-style: normal;
					font-weight: 700;
					line-height: 1.6rem;
					margin-left: .625rem;
				}
			}

			.pub-date-section {
				background: $white;
				border-radius: 0.25rem;
				display: flex;
				padding: 0.5rem 1rem;
				width: fit-content;

				.publish-date {
					color: $imperial;
					font-family: $base-font-family-sans;
					font-size: 1rem;
					font-style: normal;
					font-weight: 400;
					line-height: 1.6rem;

					b {
						font-weight: 600;
					}
				}
			}
		}

	}
}

.asset-disclaimer {
	display: flex;
	margin: 1rem 0;

	.disclmr-txt {
			color: $darkgray;
			font-family: $base-font-family-sans;
			font-size: .875rem;
			font-style: normal;
			font-weight: 400;
			line-height: 19.6px;		

			@media screen and (max-width: $disc-tablet) {
				display: -webkit-box;
				font-size: 1rem;
				line-height: 22.4px;
				margin-right: .5625rem;
				overflow: hidden;
				position: relative;
				text-overflow: ellipsis;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				white-space: normal;
			}

	}

	.arrow-icon-container {
		color: $ultramarine;
		display: none;
		position: relative;


		@media screen and (max-width: $disc-tablet) {
			display: block;
		}

		.webmd-icon-down-arrow {
			bottom: .1875rem;
			font-size: .6963rem;
			position: absolute;
			right: -.3125rem;

		}
	}

	&.show {
		.disclmr-txt {
			display : block;
			margin-right: 0;
		}

		.arrow-icon-container {
			display: none;
		}
				
	}
}

.no-js {
	.asset-footer-content {
		.sources-section {
			display: block !important;
		}
	}

	.asset-disclaimer {
		.disclmr-txt {
			display: block;
			margin-right: 0;
		}

		.arrow-icon-container {
			display: none;
		}
	}

}
</style>
